module.exports = __webpack_public_path__ + "media/images/flag_yellow-a9ebaa148953a8a7f5315496442cc7ef.png";